import React, { useEffect, useState } from "react";

import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { CircularProgress, Grid, Typography } from "@material-ui/core";
import { ROUTES } from "../../../constants/route";
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router";

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  banner: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '16px',
  },
  emailWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '40px',
  },
  paper: {
    padding: '10px',
    textAlign: 'center',
  },
}));

type CheckoutFormProps = {
  topupAmount: number;
};

const CheckoutForm: React.FC<CheckoutFormProps> = ({ topupAmount }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      if (paymentIntent) {
        switch (paymentIntent.status) {
          case "succeeded":
            setMessage("Payment succeeded!");
            setSuccess(true);
            break;
          case "processing":
            setMessage("Your payment is processing.");
            break;
          case "requires_payment_method":
            setMessage("Your payment was not successful, please try again.");
            break;
          default:
            setMessage("Something went wrong.");
            break;
        }
      }
      else {
        setMessage("Something went wrong.");
      }
    });
  }, [stripe]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `https://sejutakg.datapassport.dev${ROUTES.MERCHANT_PAYMENTS}`,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message ? error.message : "An error occurred.");
    } else {
      setMessage("An unexpected error occured.");
    }

    setIsLoading(false);
  };

  const restartProcess = () => {
    setMessage('');
    setSuccess(false);
    setIsLoading(false);
  
    history.push("/payments");

  }

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {!message && <>
        <Grid item xs={12}>
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} className={classes.paper}>
              <Typography>
                You are adding RM{topupAmount / 100}.00 to your account.
              </Typography>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} className={classes.paper}>
              <PaymentElement id="payment-element" />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} className={classes.paper}>
              <button disabled={isLoading || !stripe || !elements} id="submit">
                <span id="submit-button-text">
                  {isLoading ? <div className="spinner" id="spinner"><CircularProgress /></div> : "Pay now"}
                </span>
              </button>
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        </Grid>
      </>}
      {message &&
        <>
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} className={classes.paper}>
              <Typography>
                You are adding RM{topupAmount / 100}.00 to your account.
              </Typography>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} className={classes.paper}>
              <div id="payment-message">{message}</div>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} className={classes.paper}>
              <div>
              <button onClick={restartProcess}>{success ? 'Would you like to add more?' : 'Click here to try again.'}</button>
              </div>
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        </>}
    </form>
  );
}

export default CheckoutForm;